import React from 'react';
import { TableHead, TableRow, TableCell } from '@mui/material';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import styled from '@emotion/styled';
import { TABLE_CONSTANTS } from '../../constants';

const Heading = styled.p`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  line-height: 2rem;
  font-weight: 700;
  font-size: 1.4rem;
  gap: 0.4rem;
  margin: 0;
`;

const TableHeader = ({ showInboundColumn }: { showInboundColumn: boolean }) => {
  return (
    <TableHead>
      <TableRow sx={{ display: 'flex' }}>
        <TableCell style={{ width: `${TABLE_CONSTANTS.CAMPAIGN_NAME}px` }}>
          <Heading>Campaign name</Heading>
        </TableCell>
        <TableCell align="left" style={{ width: `${TABLE_CONSTANTS.CAMPAIGN_STAGES}px`, display: 'flex', justifyContent: 'space-between' }}>
          <Heading>
            Candidate stages
          </Heading>
          {showInboundColumn ?
            <Heading>
              Inbound
            </Heading>
            : null
          }
        </TableCell>
        <TableCell align="left" sx={{ flex: '1' }}>
          <Heading>Folder name</Heading>
        </TableCell>
        <TableCell align="left" sx={{width: "220px", display:"flex", justifyContent:"end"}}>
          <Heading></Heading>
        </TableCell>
      </TableRow>
    </TableHead>
  )
}

export default TableHeader;
